module.exports = __webpack_public_path__ + "img/draw-bottom.f6970e08.png";